class StorageService {
  constructor () {
    this.localStorage = window.localStorage;
  }

  set (key, data = null) {
    this.localStorage.setItem(key, JSON.stringify(data));
  }

  /**
   * @param key
   * @param defaultValue
   * @returns {*}
   */
  get (key, defaultValue = null) {
    const data = this.localStorage.getItem(key);

    if (data !== null) {
      if (typeof data === 'string') {
        try {
          return JSON.parse(data);
        } catch (e) {
          return data;
        }
      }

      return data;
    }

    return defaultValue;
  }

  /**
   * @param key
   */
  remove (key) {
    this.localStorage.removeItem(key);
  }
}

export default (context, inject) => {
  inject('storage', new StorageService());
};
